import React, { useState } from "react";
import Image from 'react-bootstrap/Image';
import {COMPANY_NAME} from '../../constants/constants';
import {firstChar} from "../../../javascripts/utils";
import anonymousAvatar from '../../../images/anonymous-avatar.png'

export default function UserAvatar({ user, avatarSize }) {

    if(user) {
        if(user.avatar) {
            return (
                <Image roundedCircle src={user.avatar} alt={`${user.username} - ${COMPANY_NAME} user`} width={avatarSize} height={avatarSize}></Image>
            )
        } else if(user.first_name && user.last_name && !user.generic_username) {
            return (
                <div className={'css-avatar'} style={{ '--avatar_size': `${avatarSize}px`}}>
                    <span>
                        {firstChar(user.first_name)}
                        {firstChar(user.last_name)}
                    </span>
                </div>
            )
        } else {
            return (
                <Image roundedCircle src={anonymousAvatar} alt={`${COMPANY_NAME} user`} width={avatarSize} height={avatarSize}></Image>
            )
        }
    } else {
        return (
            <Image roundedCircle src={anonymousAvatar} alt={`${COMPANY_NAME} user`} width={avatarSize} height={avatarSize}></Image>
        )
    }
}